import React from 'react';
import Layout from './layout/Layout';

const InitialMessageSection = () => {

    return (
        <Layout>
            <div className="initial-message-div">
                Global Talk
            </div>
        </Layout>
    );
};

export default InitialMessageSection;
